import React, { Component } from 'react';
import {
    Layout, Menu, Dropdown, Icon, Spin, LocaleProvider, Button
} from 'antd';
import {
    BrowserRouter as Router, Route, Redirect, Link,
} from 'react-router-dom';


import {
    addLocaleData, IntlProvider, FormattedMessage,
} from 'react-intl';
import appLocaleES from './locales/es-ES';
import appLocaleEN from './locales/en-US';

import Home from './components/views/Home';
import logotiny from './images/logotiny.png';
import MachineScanContainer from './components/containers/MachineScanContainer';
import Statistics from './components/views/Statistics';
import MachineDetailsContainer from './components/containers/MachineDetailsContainer';
import LoginContainer from './components/containers/LoginContainer';
import ProfileContainer from './components/containers/ProfileContainer';
import ContactsContainer from './components/containers/ContactsContainer';
import DiagramsContainer from './components/containers/DiagramsContainer';

import AdminCompaniesContainer from './components/containers/AdminCompaniesContainer';
import AdminCompaniesDetailContainer from './components/containers/AdminCompaniesDetailContainer';
import AdminUsersContainer from './components/containers/AdminUsersContainer';

import { app, base } from './base';
import constants from './constants';
import logo from './images/logomid.png';

import './App.css';

const { Header, Sider, Content, Footer } = Layout;

function AuthenticatedRoute({ component: Component, authenticated, ...rest }) {
    return (
        <Route
            {...rest}
            render={
                (props) => {
                    if (authenticated === true) {
                        return <Component {...props} {...rest} />;
                    }
                    return <Redirect to={{ pathname: '/login' }} />;
                }
            }
        />
    );
}

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentUser: null,
            extraUser: null,
            authenticated: false,
            loading: true,
            currentMenuOpt: ['1'],
            locale: appLocaleEN,
            collapsed: false,
            // values: {}
        };
        this.handleLogout = this.handleLogout.bind(this);
        this.handleMenuClick = this.handleMenuClick.bind(this);
    }

    toggle = () => {
        this.setState({
            collapsed: !this.state.collapsed,
        });
    }

    componentWillMount() {
        this.removeAuthListener = app.auth().onAuthStateChanged((user) => {
            // const extraUser = null;
            // const company = null;
            if (user) {
                // query extra user info
                base.fetch('users', {
                    context: this,
                    asArray: true,
                    queries: {
                        orderByChild: 'uid',
                        equalTo: user.uid,
                    },
                }).then((data) => {
                    this.setState({
                        extraUser: data[0],
                        authenticated: true,
                    });
                    if (this.state.extraUser != null) {
                        if (this.state.extraUser.lang === 'es') {
                            this.setState({
                                locale: appLocaleES,
                                loading: false,
                            });
                        } else if (this.state.extraUser.lang === 'en') {
                            this.setState({
                                locale: appLocaleEN,
                                loading: false,
                            });
                        }
                    }
                }).catch((err) => {
                    // handle error
                    console.log(err);
                    this.setState({
                        loading: false,
                    });
                });
                // console.log(extraUser);
                // base.fetch('companies/', {
                //   context: this,
                //   asArray: true,
                //   query: {
                //     orderByChild: 'uid',
                //     equalTo: 'WUxqL0Kzgvg8raii01uDt2Lbh0l2'
                //   },
                // }).then(data => {
                //   extraUser = data[0];
                // }).catch(err => {
                //   //handle error
                // });
                // user.username = this.state.extraUser.key;
                // user.extraUser = this.state.extraUser;
                this.setState({
                    currentUser: user,
                });
                // console.log(user);
            } else {
                this.setState({
                    authenticated: false,
                    loading: false,
                });
            }
        });
    }

    componentWillUnmount() {
        this.removeAuthListener();
    }

    handleLogout() {
        app.auth().signOut().then((user) => {
            this.setState({ currentUser: user, authenticated: false });
            return this;
        });
    }

    handleMenuClick(event) {
        this.setState({
            currentMenuOpt: [event.key],
        });
    }


    renderMenuTop = (
        <Menu>
            <Menu.Item>
                <Link to="/profile">
                    <Icon type="user" />
                    <span>
                        <FormattedMessage id="app.menu.profile" />
                    </span>
                </Link>
            </Menu.Item>
            <Menu.Divider />
            <Menu.Item>
                <Link to="/logout" onClick={this.handleLogout.bind(this)}>
                    <Icon type="logout" />
                    <span>
                        <FormattedMessage id="app.menu.logout" />
                    </span>
                </Link>
            </Menu.Item>
        </Menu>
    );

    renderMenu() {
        const adminMenuTitle = (
            <span>
                <Icon type="setting" />
                <span>
                    Admin
                </span>
            </span>
        );
        const { type } = this.state.extraUser;

        const adminMenu = (
            <Menu.SubMenu key="sub4" title={adminMenuTitle}>
                <Menu.Item key="6">
                    <Link to="/admin/companies">
                        <Icon type="rocket" />
                        <span>
                            <FormattedMessage id="app.menu.companies" />
                        </span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="7">
                    <Link to="/admin/users">
                        <Icon type="usergroup-add" />
                        <span>
                            <FormattedMessage id="app.menu.users" />
                        </span>
                    </Link>
                </Menu.Item>
            </Menu.SubMenu>
        );
        return (
            <Menu
                theme="dark" mode="inline" defaultSelectedKeys={['1']}
            >
                <Menu.Item key="1">
                    <Link to="/">
                        <Icon type="home" />
                        <span>
                            <FormattedMessage id="app.menu.home" />
                        </span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="2">
                    <Link to="/contacts">
                        <Icon type="book" />
                        <span>
                            <FormattedMessage id="app.menu.contacts" />
                        </span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="3">
                    <Link to="/diagrams">
                        <Icon type="area-chart" />
                        <span>
                            <FormattedMessage id="app.menu.diagrams" />
                        </span>
                    </Link>
                </Menu.Item>
                <Menu.Item key="4">
                    <Link to="/scan">
                        <Icon type="scan" />
                        <span>
                            <FormattedMessage id="app.menu.scan_qr" />
                        </span>
                    </Link>
                </Menu.Item>
                {/* <Menu.Item key="4">
                    <Link to="/login">
                        <Icon type="login" />
                        <span>
                            <FormattedMessage id="app.menu.login" />
                        </span>
                    </Link>
                </Menu.Item> */}
                {/* <Menu.Item key="5">
                    <Link to="/profile">
                        <Icon type="user" />
                        <span>
                            <FormattedMessage id="app.menu.profile" />
                        </span>
                    </Link>
                </Menu.Item> */}
                {/* <Menu.Item key="8">
                    <Link to="/logout" onClick={this.handleLogout}>
                        <Icon type="logout" />
                        <span>
                            <FormattedMessage id="app.menu.logout" />
                        </span>
                    </Link>
                </Menu.Item> */}
                { type === constants.SADMIN_ROLE && adminMenu }
            </Menu>
        );
    }

    renderRoutes() {
        return (
            <div className="generic-container">
                <Route
                    exact
                    path="/login"
                    render={() => <LoginContainer authenticated={this.state.authenticated} />}
                />
                <Route
                    exact
                    path="/"
                    render={() => (
                        <Home
                            authenticated={this.state.authenticated}
                            extraUser={this.state.extraUser}
                            user={this.state.currentUser}
                        />
                    )}
                />
                <AuthenticatedRoute
                    authenticated={this.state.authenticated}
                    exact
                    path="/statistics"
                    component={Statistics}
                />
                <AuthenticatedRoute
                    authenticated={this.state.authenticated}
                    user={this.state.currentUser}
                    extraUser={this.state.extraUser}
                    exact
                    path="/profile"
                    component={ProfileContainer}
                />
                <AuthenticatedRoute
                    authenticated={this.state.authenticated}
                    user={this.state.currentUser}
                    extraUser={this.state.extraUser}
                    exact
                    path="/diagrams"
                    component={DiagramsContainer}
                />
                <AuthenticatedRoute
                    authenticated={this.state.authenticated}
                    exact
                    path="/scan"
                    component={MachineScanContainer}
                />

                <AuthenticatedRoute
                    authenticated={this.state.authenticated}
                    exact
                    path="/contacts"
                    user={this.state.currentUser}
                    extraUser={this.state.extraUser}
                    component={ContactsContainer}
                />

                <AuthenticatedRoute
                    authenticated={this.state.authenticated}
                    user={this.state.currentUser}
                    extraUser={this.state.extraUser}
                    path="/machine/:machineId"
                    component={MachineDetailsContainer}
                />
                <AuthenticatedRoute
                    authenticated={this.state.authenticated}
                    user={this.state.currentUser}
                    path="/admin/companies"
                    component={AdminCompaniesContainer}
                />
                <AuthenticatedRoute
                    authenticated={this.state.authenticated}
                    user={this.state.currentUser}
                    path="/admin/company/:companyId"
                    component={AdminCompaniesDetailContainer}
                />
                <AuthenticatedRoute
                    authenticated={this.state.authenticated}
                    path="/admin/users"
                    component={AdminUsersContainer}
                />
                <Route
                    path="/logout"
                    render={() => <Redirect to={{ pathname: '/' }} />}
                />
            </div>
        );
    }

    renderHelper() {
        if (this.state.loading === true) {
            return (
                <div className="loading">
                    <Spin size="large" />
                </div>
            );
            // esto deberia decir algo como que esta haciendo el login
        }
        return (
            <Router>
                <span>
                    { this.state.authenticated && (
                        <Layout style={{ minHeight: '100vh' }}>
                            <Sider
                                trigger={null}
                                collapsible
                                collapsed={this.state.collapsed}
                            >
                                <div className="logo" style={{ background: 'white', }}>
                                    <img src={logotiny} alt="MID" width="40" />
                                </div>
                                {this.renderMenu()}
                            </Sider>
                            <Layout>
                                <Header className="menu-top-header" style={{ background: '#fff', padding: 0 }}>
                                    <Icon
                                        className="trigger"
                                        type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'}
                                        onClick={this.toggle}
                                    />
                                    <Dropdown overlay={this.renderMenuTop}>
                                        <Button style={{ marginLeft: 8 }}>
                                            <Icon type="user" /> Profile <Icon type="down" />
                                        </Button>
                                    </Dropdown>
                                </Header>
                                <Content style={{ margin: '24px 16px 0' }}>
                                    <div style={{ padding: 24, background: '#fff', minHeight: 360 }}>
                                        <div className="container">
                                            {this.renderRoutes()}
                                        </div>
                                    </div>
                                </Content>
                                <Footer style={{ textAlign: 'center' }}>
                                    MID Project ©2018
                                </Footer>
                            </Layout>
                        </Layout>
                    )}
                    { !this.state.authenticated &&(
                        <div className="info-container">
                            {this.renderRoutes()}
                        </div>
                    )}

                </span>
            </Router>
        );
    }

    render() {
        addLocaleData(this.state.locale.data);
        return (
            <LocaleProvider locale={this.state.locale.antd}>
                <IntlProvider
                    locale={this.state.locale.locale}
                    messages={this.state.locale.messages}
                >
                    {this.renderHelper()}
                </IntlProvider>
            </LocaleProvider>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js